export default __webpack_public_path__ + "static/media/img-0615-monaco-full-face.aa6d040d.png";